export const forms = {
  newsletter: {
    email: 'email-newsletter-reviewer-home'
  }
} as const;
